import { render, staticRenderFns } from "./VDynamicList.vue?vue&type=template&id=2fbffa84&scoped=true"
import script from "./VDynamicList.vue?vue&type=script&lang=js"
export * from "./VDynamicList.vue?vue&type=script&lang=js"
import style0 from "./VDynamicList.vue?vue&type=style&index=0&id=2fbffa84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbffa84",
  null
  
)

export default component.exports